import axios from "axios";

const SAFE_METHODS = new Set(["get", "head", "options"]);
const CSRF_COOKIE = "gp_csrf";

export function readCookie(name) {
  const prefix = `${encodeURIComponent(name)}=`;
  const item = document.cookie.split("; ").find((entry) => entry.startsWith(prefix));
  return item ? decodeURIComponent(item.slice(prefix.length)) : "";
}

const api = axios.create({
  baseURL: "/api",
  withCredentials: true,
  timeout: 30_000,
  headers: { Accept: "application/json" },
});

api.interceptors.request.use((config) => {
  if (!SAFE_METHODS.has((config.method || "get").toLowerCase())) {
    const csrf = readCookie(CSRF_COOKIE);
    if (csrf) config.headers["X-CSRF-Token"] = csrf;
  }
  return config;
});

let refreshPromise = null;

async function refreshSession() {
  if (!refreshPromise) {
    refreshPromise = api.post("/auth/refresh", {}, { skipAuthRefresh: true }).finally(() => {
      refreshPromise = null;
    });
  }
  return refreshPromise;
}

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const request = error.config || {};
    const isUnauthorized = error.response?.status === 401;
    const isAuthRequest = String(request.url || "").includes("/auth/");
    if (isUnauthorized && !isAuthRequest && !request.skipAuthRefresh && !request.__retried) {
      request.__retried = true;
      try {
        await refreshSession();
        return api(request);
      } catch {
        // The refresh endpoint clears no UI state; the auth provider will render login.
      }
    }
    return Promise.reject(error);
  },
);

export default api;
